<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    max-width="400px"
    transition="dialog-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn fab color="error" dark v-bind="attrs" v-on="on">
        <v-icon>fas fa-plus</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dark color="teal darken-3">
        <v-toolbar-title>New Client</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn text icon @click="close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pt-5">
        <v-form ref="ClientForm">
          <v-text-field
            outlined
            shaped
            v-model.trim="Client.Name"
            :rules="[rules.required]"
            label="Client Name"
            name="ClientName"
            id="ClientName"
          ></v-text-field>

          <v-text-field
            outlined
            shaped
            v-model="Client.phone"
            :rules="[rules.required]"
            label="Client Phone"
            id="ClientPhone"
          ></v-text-field>

          <BaseNumInput
            v-if="!isEditing"
            :rules="[v => !!v || 'Invalid Amount']"
            append-icon="fas fa-hand-holding-usd"
            outlined
            shaped
            v-model.trim="Client.Amount"
            label="Debt Amount"
          ></BaseNumInput>

          <p class="font-weight-black mt-3 text-center" v-html="msgError"></p>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="isEditing"
          @click="CancelEdite"
          :loading="clicked"
          class="elevation-6"
          rounded
          color="error"
          dark
          width="150"
          >Cancel</v-btn
        >
        <v-spacer v-if="isEditing"></v-spacer>
        <v-btn
          :block="!isEditing"
          @click="UpdateOrSave"
          :loading="clicked"
          class="elevation-6"
          rounded
          color="teal darken-3"
          dark
          width="150"
          >{{ isEditing ? "Update" : "Save" }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    OnFinish: { type: Function, required: true },
    isEditing: { type: Boolean, required: true, default: false },
    OnEdite: { type: Object, required: true },
  },
  data() {
    return {
      ID: "",
      ClientURL: "/customer",
      dialog: false,
      msgError: "",
      clicked: false,
      Client: {
        Name: "",
        phone: "",
        Amount: 0,
      },
      rules: {
        required: value => !!value || "Required.",
      },
    };
  },
  computed: {
    // MyAmount() {
    //   return this.Client.Amount;
    // }
  },
  watch: {
    // MyAmount(v) {
    //   this.Client.phone = v.toString();
    // },
    isEditing(val) {
      if (val) {
        this.dialog = true;
        this.ClientEdite(this.OnEdite);
      }
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.$refs.ClientForm.reset();
      this.$emit("input", false);
    },
    UpdateOrSave() {
      if (this.isEditing) this.OnClientUpdate();
      else this.OnClientSave();
    },
    CancelEdite() {
      this.close();
      this.msgError = "";
      this.ID = "";
    },
    OnClientUpdate() {
      // console.log("Updating");
      this.msgError = "";
      if (this.$refs.ClientForm.validate() && this.ID) {
        this.clicked = true;
        this.$store
          .dispatch("UPDATE_ONLY", {
            url: this.ClientURL,
            data: { ...this.Client, ID: this.ID },
          })
          .then(result => {
            this.clicked = false;
            // this.$refs.ClientForm.reset();
            // console.log(result);
            this.ID = "";
            this.OnFinish(result.data);
            this.close();
          })
          .catch(err => {
            this.clicked = false;
            if (err.response && err.response.data)
              this.msgError = err.response.data;
            // console.log(err);
          });
      }
    },
    OnClientSave() {
      this.msgError = "";
      if (this.$refs.ClientForm.validate()) {
        this.clicked = true;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: this.ClientURL,
            data: {
              ...this.Client,
              date: this.Current().date,
              time: this.Current().time,
            },
          })
          .then(result => {
            this.clicked = false;
            this.$refs.ClientForm.reset();
            this.OnFinish(result.data);
          })
          .catch(err => {
            this.clicked = false;
            this.msgError = err.response.data;
            // console.log(err);
          });
      }
    },
    ClientEdite(E_Client) {
      // console.log(E_Client);
      this.ID = E_Client._id;
      this.msgError = "";
      this.isEditing = true;
      this.Client.Name = E_Client.Name;
      this.Client.phone = E_Client.phone;
    },
  },
};
</script>
